export const RCVP = 'RCVP';
export const RCAUT = 'RCAUT';
export const ASSVEH1 = 'ASSVEH1';
export const ASSVEH2 = 'ASSVEH2';

export const COVERAGE_IDS: Record<string, number> = {
  [RCAUT]: 54,
  [RCVP]: 55,
  [ASSVEH1]: 56,
  [ASSVEH2]: 54,
};
